import { atom } from 'recoil';
import { IVendor, IVendorAddress } from '@shared/types/vendor';

export const VENDOR_COLLECTION = atom({
  key: 'VENDOR_COLLECTION',
  default: 'vendors',
});

export const vendorRecordsAtom = atom<IVendor[]>({
  key: 'vendorRecordAtom',
  default: [],
});

export const vendorSearchQueryAtom = atom({
  key: 'vendorSearchQueryAtom',
  default: sessionStorage.getItem('vendor.query.string') || '',
});

export const currentVendorPageAtom = atom({
  key: 'currentVendorPageAtom',
  default: 1,
});

export const activeVendorDisplayAtom = atom<'active'|'inactive'|'all'>({
  key: 'ActiveVendorDisplayAtom',
  default: sessionStorage.getItem('activeVendorDisplayType') as 'active'|'inactive'|'all' || 'all',
});

const defaultVendorAddress: IVendorAddress = {
  Line1: '',
  Line2: '',
  Line3: '',
  Line4: '',
  City: '',
  CountrySubDivisionCode: '',
  PostalCode: '',
  Country: '',
};

const defaultVendor: IVendor = {
  Id: '',
  vendorCode: '',
  DisplayName: '',
  CompanyName: '',
  PrintOnCheckName: '',
  GivenName: '',
  FamilyName: '',
  PrimaryPhone: { FreeFormNumber: '' },
  Mobile: { FreeFormNumber: '' },
  PrimaryEmailAddr: { Address: '' },
  BillAddr: { ...defaultVendorAddress },
  ShipAddr: { ...defaultVendorAddress },
  useShipAddrAsBillAddr: false,
  TermRef: { value: '' },
  AcctNum: '',
  Balance: 0,
  Vendor1099: false,
  CurrencyRef: { name: 'United States Dollar', value: 'USD' },
  Notes: '',
  Active: true,
  SyncToken: '0',
  MetaData: { CreateTime: '', LastUpdatedTime: '' },
  leadTime: 0,
  domain: 'QBO',
  sparse: false,
};

export const currentVendorAtom = atom<IVendor>({
  key: 'currentVendorAtom',
  default: defaultVendor,
});

export const vendorEditedAtom = atom<boolean>({
  key: 'vendorEditedAtom',
  default: false,
});
